import { render, staticRenderFns } from "./beautySetMeal.vue?vue&type=template&id=a7063d52&scoped=true"
import script from "./beautySetMeal.vue?vue&type=script&lang=js"
export * from "./beautySetMeal.vue?vue&type=script&lang=js"
import style0 from "./beautySetMeal.vue?vue&type=style&index=0&id=a7063d52&prod&scoped=true&lang=css"
import style1 from "./beautySetMeal.vue?vue&type=style&index=1&id=a7063d52&prod&scoped=true&lang=less"
import style2 from "./beautySetMeal.vue?vue&type=style&index=2&id=a7063d52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7063d52",
  null
  
)

export default component.exports